const DOC_BASE_ROUTE = '/doc';

export const DOC_API_ROUTES = {
  baseRoute: () => DOC_BASE_ROUTE,
  getStatus: () => `${DOC_BASE_ROUTE}/read_status`,
  deeplinkStatus: (deeplink: string) =>
    `${DOC_BASE_ROUTE}/read_Status/${deeplink}`,
};
